export function toE164UsMobile(phone) {
  const raw = String(phone ?? "").trim();
  const digits = raw.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+${digits}`;
  }
  if (digits.length === 10) {
    return `+1${digits}`;
  }
  return "";
}

export function isValidUsMobile(phone) {
  return Boolean(toE164UsMobile(phone));
}

export function extractPhoneVerificationToken(response) {
  return String(response?.Data?.phoneVerificationToken ?? "").trim();
}

export function buildClubRegistrationPayload(registerData, phoneVerificationToken) {
  return {
    username: registerData.email?.trim(),
    email: registerData.email?.trim(),
    password: registerData.password?.trim(),
    mobile: toE164UsMobile(registerData.phone),
    phoneVerificationToken,
    firstName: registerData.firstName?.trim(),
    lastName: registerData.lastName?.trim(),
    club: {
      clubName: registerData.organizationName?.trim(),
      clubDescription: registerData.description?.trim(),
    },
    isClubOwner: true,
    isCoach: false,
    isGuardian: false,
    isGuest: false,
    isPlayer: false,
    gameId: registerData.game,
    pathName: typeof window !== "undefined" ? window.location.pathname : "",
  };
}
